import { FormLabel, forwardRef, Textarea, InputGroup, TextareaProps, Text } from '@chakra-ui/react';
import { ReactNode } from 'react';
import { WithFormControl, WithFormControlProps } from '../WithFormControl';

export interface TextareaFieldProps extends TextareaProps {
  label?: ReactNode;
  helperText?: string;
  error?: string;
  rootProps?: WithFormControlProps;
}

export const TextareaField = forwardRef<TextareaFieldProps, 'input'>(({ label, helperText, error, rootProps, ...props }, ref) => {
  return (
    <WithFormControl {...rootProps}>
      <InputGroup display='flex' flexDirection='column'>
        {label && (
          <FormLabel color='text.main' fontSize='1rem' m={0}>
            {label}
          </FormLabel>
        )}

        <Textarea
          border='none'
          borderBottom='1px solid black'
          borderRadius={0}
          maxLength={4000}
          p={0}
          _hover={{ borderColor: 'black' }}
          _focusVisible={{ borderWidth: 2, borderColor: 'brand.300' }}
          _invalid={{ borderTopWidth: 0, borderX: 0, borderBottomWidth: 2, borderColor: 'red.500' }}
          isInvalid={!!error}
          {...props}
          ref={ref}
        />

        {helperText ? (
          <Text fontSize='12px' color='gray.500' mt={1}>
            {helperText}
          </Text>
        ) : null}

        {error ? (
          <Text mt={2} fontSize='14px' color='red.500'>
            {error}
          </Text>
        ) : null}
      </InputGroup>
    </WithFormControl>
  );
});
